export default {
  solicitacao: state => state.solicitacao
}
